import React, { useEffect, useState} from "react";
import Header from "../components/Header";
import { Link } from "react-router-dom";
import mvBanner1 from "../images/mvBanner1.png";
import mvBanner2 from "../images/mvBanner2.png";
import mvBanner3 from "../images/mvBanner3.png";
import { useTranslation } from 'react-i18next';
import { useAxios } from "../services/useAxios";
import Nodata from "../components/NoData";

export default function Event() {
    const { t } = useTranslation();
    const [page, setPage] = useState(0);

    const [data, setData] = useState({});
    const [dataList, setDataList] = useState([]);
    const [request] = useAxios();


    const fetchData = async (pageIndex) => {
        
        const response = await request.post("/app/goods/getGoodsEventDcListAPI", {
            pageIndex : pageIndex
        });
        if(response.data.resultCode === 200){           
            setData(response.data.result);        
            console.log(response.data.result)     
            setDataList((prevData) => [...prevData, ...response.data.result.resultList]);
            
        }            
    };


 

    useEffect(() => {
        if(page > 0){
            fetchData(page);    
        }
      }, [page]);

      
  const handleObserver = (entries) => {
    const target = entries[0];
    if (target.isIntersecting ) {
        setPage((prevPage) => prevPage + 1);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(handleObserver, {
      threshold: 0, //  Intersection Observer의 옵션, 0일 때는 교차점이 한 번만 발생해도 실행, 1은 모든 영역이 교차해야 콜백 함수가 실행.
    });
    // 최하단 요소를 관찰 대상으로 지정함
    const observerTarget = document.getElementById("observer");
    // 관찰 시작
    if (observerTarget) {
      observer.observe(observerTarget);
    }
  }, []);

    return (
        <div>
            <div className="backGround bgBlue"></div>
            <Header type="cart" pageTitle={t(`Message.salee_event_list_title`)}/>
            
            <div className="event">
                {dataList && dataList.length === 0?(
                <div className="floatCenter">
                    <Nodata text={t(`Message.salee_event_list_empty`)}/>
                </div> 
                ):(
                <>
                {dataList && dataList.map((obj, index) => (
                <>
                <div className={obj.eventActAt === 'N'?"eventCont fin":"eventCont"}>
                    <div className="imgWr">
                        <img src={"https://www.salee.co.kr/com/cmm/getGoodsEventImageView.sale?goodsEventFileTy=d&goodsEventFileSn="+obj.eventDcSn} alt={obj.replcTextCn} />
                        {obj.eventActAt === 'N'?(<p className="eventFin">{t(`Message.salee_event_list_end_of_event`)}</p>):null}
                    </div>
                    <div className="cont">
                        <p className="tit">{obj.eventDc}</p>
                        <p className="date">{obj.eventBgnde?(obj.eventBgnde +" ~ "+ obj.eventEndde):"별도공지"}</p>
                    </div>
                </div>
                </>
                 ))}   
                </>
                )}
                <div id="observer" style={{ height: "10px" }}></div>
            </div>
        </div>      
    );
};